export default {
  title: {
    list: 'System Notification',
    detail: 'Notification Detail'
  },
  label: {
    notification: 'System Notification',
    read: 'Read',
    unread: 'Unread'
  },
  button: {
    return: 'Return'
  }
}
